export default __webpack_public_path__ + "static/media/Days_04.c560aa29.png";